import { render } from "./Modal.vue?vue&type=template&id=1cbd1789&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=1cbd1789&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbd1789"]])

export default __exports__